var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6968_4939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9154 4.6665L8.93536 8.4665C8.72955 8.59545 8.49158 8.66384 8.2487 8.66384C8.00582 8.66384 7.76785 8.59545 7.56203 8.4665L1.58203 4.6665M2.91536 2.6665H13.582C14.3184 2.6665 14.9154 3.26346 14.9154 3.99984V11.9998C14.9154 12.7362 14.3184 13.3332 13.582 13.3332H2.91536C2.17898 13.3332 1.58203 12.7362 1.58203 11.9998V3.99984C1.58203 3.26346 2.17898 2.6665 2.91536 2.6665Z",
    stroke: "#23296F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6968_4939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8028f3c7.svg";
export { ForwardRef as ReactComponent };